<div class="d-flex flex-column align-items-center flex-grow-1 overflow-auto p-3 p-lg-5 gap-3">

    <h3 class="text-center fw-bold m-0">{{ "receipt-view.title" | translate }}</h3>

    <div *ngIf="state === 'loading'" class="d-flex flex-grow-1 align-items-center justify-content-center">
        <mat-spinner class="zx-medium-icon-size"></mat-spinner>
    </div>

    <ng-container *ngIf="state === 'ready'">
        <div class="d-flex flex-wrap justify-content-center gap-2 w-100">
            <a mat-raised-button color="primary" class="text-white rounded-pill zx-receipt-btn" [href]="downloadUrl"
                target="_blank" rel="noopener">
                {{ "receipt-view.open" | translate }}
            </a>
            <a mat-stroked-button class="rounded-pill zx-receipt-btn" [href]="downloadUrl" download="eazix-receipt.pdf">
                {{ "receipt-view.download" | translate }}
            </a>
        </div>
        <!-- inline preview where the browser can show PDFs in a frame (desktop) -->
        <iframe class="zx-receipt-preview d-none d-lg-block" [src]="previewUrl"
            [title]="'receipt-view.title' | translate"></iframe>
    </ng-container>

    <p *ngIf="state === 'not-found'" class="text-center m-0 py-4">{{ "receipt-view.not-found" | translate }}</p>
    <p *ngIf="state === 'error'" class="text-center m-0 py-4">{{ "receipt-view.error" | translate }}</p>

</div>
